import React from 'react'
import Topsec from '../../Component/Contact/Topsec'
import Contactuss from '../../Component/Contact/Contactus'
import Seo from '../../Component/Seo'

function Contactus() {
  return (
    <div>
      <Seo
        title='Contact Halal Wealth Support Team | Halal Wealth'
        description='Need help with your account or products? Contact Halal Wealth for support on halal savings, investments, asset financing, and general inquiries.'
        pathname='/contactus'
      />
      <Topsec/>
      <Contactuss/>
      <section className="px-6 py-16 sm:px-24 bg-primary-color5">
        <h2 className="text-[24px] sm:text-[36px] text-text-color1 mb-6">How we can help you</h2>
        <p className="text-[16px] text-[#5C556C] mb-4">
          Our support team helps users across every stage of the Halal Wealth experience, from account setup to product usage and issue resolution. If you are new to the platform, we can guide you through onboarding, profile completion, and the best way to get started based on your savings or investment goals. If you are already using the app, we can help with transaction questions, account verification, product eligibility, and understanding the status of your requests.
        </p>
        <p className="text-[16px] text-[#5C556C] mb-4">
          We also assist with questions on halal compliance and product structure. Many users want to understand how savings, investment, and financing products are designed to avoid riba and align with ethical standards. Our team can explain product mechanics in clear language so you can make informed decisions. For security or account access concerns, contact us immediately and we will support verification and recovery steps as quickly as possible.
        </p>
        <p className="text-[16px] text-[#5C556C]">
          To speed up support, include your registered email address, a short description of the issue, and any relevant screenshots in your message. This helps us investigate faster and reduces back-and-forth. We aim to provide responses that are practical and complete, so you can resolve issues without delays and continue building your financial goals with confidence.
        </p>
      </section>
    </div>
  )
}

export default Contactus
